export const mailingCategories = [
  {
    key: "detailsNotPaid",
    label: "Started, but not paid",
    mailKey: "application_incomplete_unpaid",
    filterFunc: s => !s.feePaid && !s.submitted,
    total: 0,
    mailed: 0,
    unsent: 0,
    sending: false
  },
  {
    key: "paidNotSubmitted",
    label: "Paid, but not submitted",
    mailKey: "application_incomplete",
    filterFunc: s => s.feePaid && !s.submitted,
    total: 0,
    mailed: 0,
    unsent: 0,
    sending: false
  },
  /* {
    key: "notShortlisted",
    label: "Not in return-to list",
    mailKey: "not_shortlisted",
    filterFunc: s => s.feePaid && s.submitted && !s.shortlisted,
    total: 0,
    mailed: 0,
    unsent: 0,
    sending: false
  },
  {
    key: "shortlisted",
    label: "Return to",
    mailKey: "shortlisted",
    filterFunc: s => s.feePaid && s.submitted && s.shortlisted && !s.ineligible,
    total: 0,
    mailed: 0,
    unsent: 0,
    sending: false
  }, */
  {
    key: "notSelected",
    label: "Not shortlisted",
    mailKey: "not_selected",
    filterFunc: s =>
      s.feePaid && s.submitted && !s.hasSelectedWork,
    total: 0,
    mailed: 0,
    unsent: 0,
    sending: false
  },
  {
    key: "selected",
    label: "Shortlisted",
    mailKey: "selected",
    filterFunc: s =>
      s.feePaid && s.submitted && s.shortlisted && s.hasSelectedWork && !s.ineligible,
    total: 0,
    mailed: 0,
    unsent: 0,
    sending: false
  }
];

export const coreMailKeys = ['password_reset', 'application_submitted', 'application_incomplete', 'unsuccessful_selected'];